(function (angular) {
	'use strict';

	angular
		.module('investorDashboard')
		.controller('DashboardTransactions', [
			'APP_BASE_PATH',
			'globalConfig',
			'INVESTMENT_ENTITY_ID',
			'ReitElementFactory',
			'TransactionsFactory',
			DashboardTransactionsFunction
		]);

	function DashboardTransactionsFunction(
		APP_BASE_PATH,
		globalConfig,
		INVESTMENT_ENTITY_ID,
		ReitElementFactory,
		TransactionsFactory) {

		var dashboard = this;
		dashboard.loading = true;
		dashboard.basePath = APP_BASE_PATH;
		
		dashboard.$onInit = function() {
			angular.extend(dashboard, globalConfig);
			dashboard.investmentEntityId = INVESTMENT_ENTITY_ID;

			ReitElementFactory.getReitElementListsForDashboard()
				.then(function(reitElementLists) {
					angular.extend(dashboard, reitElementLists);
				});

			TransactionsFactory.getTransactions()
				.then(function(response) {
					dashboard.loading = false;
					dashboard.completeTransactionTable = response.completeTransactions;
					dashboard.incompleteTransactionTable = response.incompleteTransactions;
				});
		};
	}
})(window.angular);
